import Item from '@mui/material/MenuItem';
import styled from '@emotion/styled';

export default styled(Item)``;
